import { useState, useEffect } from 'react';

export default function HeroSection() {
  const [currentText, setCurrentText] = useState(0);
  const animatedTexts = [
    'Coaches.',
    'Athletes.',
    'Parents.',
    'Clubs.',
    'Sports Organizations.'
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentText((prev) => (prev + 1) % animatedTexts.length);
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  return (
    <section id="home" className="relative min-h-[calc(100dvh-3.5rem)] sm:min-h-screen flex items-center justify-center overflow-hidden pt-14 sm:pt-16 lg:pt-20">
      {/* Background Video */}
      <div className="absolute inset-0 z-0">
        <video
          autoPlay
          muted
          loop
          playsInline
          className="w-full h-full object-cover"
        >
          <source src="/images/Website_Video_New.mp4" type="video/mp4" />
        </video>
        <div className="absolute inset-0 bg-black/60"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 page-container text-center">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-3xl sm:text-4xl md:text-6xl lg:text-7xl font-bold mb-4 sm:mb-6 lg:mb-8 leading-tight">
            <span className="block mb-2 sm:mb-4">CONQUER LEGACY-DEFINING</span>
            <span className="block text-orange-500">SPORTING STORIES.</span>
          </h1>
          
          <div className="mb-6 sm:mb-10 lg:mb-12">
            <h2 className="text-lg sm:text-xl md:text-2xl lg:text-3xl font-light mb-2 sm:mb-4">
              A Platform Made for
            </h2>
            <div className="h-10 sm:h-14 lg:h-16 flex items-center justify-center">
              <h2 className="text-lg sm:text-xl md:text-2xl lg:text-3xl font-light text-orange-500 transition-all duration-500">
                {animatedTexts[currentText]}
              </h2>
            </div>
          </div>

          <button 
            onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
            className="group relative bg-orange-500 hover:bg-orange-600 text-black font-semibold px-6 py-3 sm:px-8 sm:py-4 text-sm sm:text-base rounded-full transition-all duration-300 transform hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            <span className="relative z-10">Send us a Message</span>
            <div className="absolute inset-0 bg-white opacity-0 group-hover:opacity-20 rounded-full transition-opacity duration-300"></div>
          </button>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-5 sm:bottom-8 left-1/2 transform -translate-x-1/2 z-10">
        <div className="w-5 h-8 sm:w-6 sm:h-10 border-2 border-white rounded-full flex justify-center">
          <div className="w-1 h-3 bg-white rounded-full mt-2 animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}
